import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './projects/dashboard/dashboard.component';

const routes: Routes = [

  { path: '', component: DashboardComponent },

  
  { path: 'dashboard', component: DashboardComponent },

  
  {
    path: 'projectDELPHY', loadChildren: () =>
      import('./project/projectDELPHY-routing.module').then(m => m.ProjectDELPHYRoutingModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DelphyRoutingModule {
 
 }
